import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface Props {
    isActive?: boolean;
}

export default function ActiveIndicator({ isActive }: Props) {
    if (isActive == undefined) {
        return null;
    }
    return isActive ? <CheckCircleIcon color={"success"} /> : <CancelIcon color={"error"} />;
}
